module.exports = __webpack_public_path__ + "img/ANTENNA 3 RED.da048dd.svg";